export const GET_COURSE_DATA_BY_ID = "GET_COURSE_DATA_BY_ID";
export const GET_COURSE_DATA_BY_ID_SUCCESS = "GET_COURSE_DATA_BY_ID_SUCCESS";
export const GET_COURSE_DATA_BY_ID_FAIL = "GET_COURSE_DATA_BY_ID_FAIL";
export const COURSE_STORE_RESET = "COURSE_STORE_RESET";

const initialState = {
  error: {},
  isLoading: true,
  courses: {},
};

export const getCourseDataById = (id, userId) => {
  return { type: GET_COURSE_DATA_BY_ID, payload: { id, userId } };
};

export const getCourseDataByIdSuccess = (data) => {
  return { type: GET_COURSE_DATA_BY_ID_SUCCESS, payload: data };
};

export const getCourseDataByIdFail = (id, error) => {
  return { type: GET_COURSE_DATA_BY_ID_FAIL, payload: { id, error } };
};

export const resetCourseStore = () => {
  return { type: COURSE_STORE_RESET, payload: {} };
};

const coursesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COURSE_DATA_BY_ID: {
      return { ...state, isLoading: true };
    }
    case GET_COURSE_DATA_BY_ID_SUCCESS: {
      return {
        ...state,
        courses: { ...state.courses, [action.payload.id]: action.payload },
        isLoading: false,
      };
    }
    case GET_COURSE_DATA_BY_ID_FAIL: {
      return {
        ...state,
        error: {
          ...state.error,
          [action.payload.id]: action.payload.error.message,
        },
        isLoading: false,
      };
    }

    case COURSE_STORE_RESET: {
      return { ...state, courses: {} };
    }
    default:
      return { ...state };
  }
};
export default coursesReducer;
